module.exports = __webpack_public_path__ + "img/comfirm.9051a968.svg";